/**
 * Constants for PromotionalSection component
 */

export const BACKGROUND_IMAGE_URL = 'https://images.unsplash.com/photo-1566397964453-d9c3032c949a?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1035';

export const METRICS_DATA = [
  {
    label: 'Revenue',
    value: '₹12,450',
    change: '2.8% from last month',
    changeType: 'positive',
  },
  {
    label: 'Total Queries',
    value: '1,243',
    change: '12% from last month',
    changeType: 'positive',
  },
];

export const SERVICES_DATA = [
  { name: 'Customer Support', value: 248 },
  { name: 'Technical Issues', value: 188 },
  { name: 'Feature Requests', value: 160 },
  { name: 'Billing Queries', value: 132 },
];

export const CHART_BAR_HEIGHTS = [28, 52, 18, 68, 38, 62, 45, 75, 55, 82, 35, 58];

export const HEADING_DATA = {
  title: 'Command Your Operations with Confidence',
  subtitle: 'From query tracking to analytics — Airport Authority of India simplifies every detail.',
};

// Animation keyframes
export const ANIMATION_KEYFRAMES = {
  fadeInUp: {
    from: {
      opacity: 0,
      transform: 'translateY(20px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  fadeInDown: {
    from: {
      opacity: 0,
      transform: 'translateY(-20px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  slideInLeft: {
    from: {
      opacity: 0,
      transform: 'translateX(-30px)',
    },
    to: {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
  slideInRight: {
    from: {
      opacity: 0,
      transform: 'translateX(30px)',
    },
    to: {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
  slideInUp: {
    from: {
      opacity: 0,
      transform: 'translateY(30px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  fadeIn: {
    from: {
      opacity: 0,
      transform: 'translateX(-10px)',
    },
    to: {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
};

// Glassmorphism style constants
export const GLASS_CARD_BASE_STYLES = {
  backgroundColor: 'rgba(255, 255, 255, 0.12)',
  backdropFilter: 'blur(16px) saturate(180%)',
  WebkitBackdropFilter: 'blur(16px) saturate(180%)',
  border: '1px solid rgba(255, 255, 255, 0.25)',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.3)',
};

export const GLASS_CARD_HOVER_STYLES = {
  backgroundColor: 'rgba(255, 255, 255, 0.2)',
  boxShadow: '0 16px 48px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.4)',
  border: '1px solid rgba(255, 255, 255, 0.35)',
};
